import { render, staticRenderFns } from "./RemoveRoleDialog.vue?vue&type=template&id=a7095e12&scoped=true"
import script from "./RemoveRoleDialog.vue?vue&type=script&lang=js"
export * from "./RemoveRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./RemoveRoleDialog.vue?vue&type=style&index=0&id=a7095e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7095e12",
  null
  
)

export default component.exports